export default "__VITE_ASSET__6f94e6c6__"